import { render } from "./Dashboards.vue?vue&type=template&id=6b6befbc&scoped=true"
import script from "./Dashboards.vue?vue&type=script&lang=js"
export * from "./Dashboards.vue?vue&type=script&lang=js"

import "./Dashboards.vue?vue&type=style&index=0&id=6b6befbc&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6befbc"]])

export default __exports__